module.exports = __webpack_public_path__ + "static/media/SL-Application_navigation-globalicon.36be134f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/SL-Application_navigation-globalicon.svg
// module id = 810
// module chunks = 1